var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1248 2.838L22.2444 0H0V25.402H2.57637V2.53846H21.2138L23.3213 4.63523L25.4442 6.70662V30.4615H2.57637V24.4962H0V33H28V5.65062L25.1248 2.838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66763 17.6512H23.3382V19.186H4.66763V17.6512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66763 22.2558H23.3382V23.7907H4.66763V22.2558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66763 26.8605H23.3382V28.3953H4.66763V26.8605Z",
    fill: "black"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.5f113789bcdc30972066cb4ad7c23991.svg";
export { ForwardRef as ReactComponent };